<template>
  <div>
    <div class="text-3xl mb-8">Stammdaten</div>

    <div class="grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
      <div class="sm:col-span-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Firmenprofil</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          Bitte beachten Sie, dass localTicketing momentan nur von Gewerbetreibenden benutzt werden
          kann.
        </p>
      </div>

      <basic-input
        label="Firmenname"
        v-model="organizerInput.company_name"
        class="sm:col-span-3"
        :error="errors['company_name']"
        disabled
      />

      <basic-input
        label="Vertretungsberechtigter"
        v-model="organizerInput.authority_name"
        class="sm:col-span-3"
        :error="errors['authority_name']"
        disabled
      />

      <basic-input
        label="Adresse"
        v-model="organizerInput.street"
        class="sm:col-span-3"
        :error="errors['street']"
      />

      <basic-input
        label="Stadt"
        v-model="organizerInput.city"
        class="sm:col-span-3"
        :error="errors['city']"
      />

      <basic-input
        label="Postleitzahl"
        v-model="organizerInput.zip_code"
        class="sm:col-span-3"
        :error="errors['zip_code']"
      />

      <basic-select
        class="sm:col-span-3"
        label="Land"
        v-model="organizerInput.country"
        :error="errors['country']"
      >
        <option value="NL">Niederlande</option>
        <option value="DE">Deutschland</option>
      </basic-select>

      <div class="sm:col-span-6 border-t pt-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Ansprechpartner</h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          Wir benutzen diese Informationen nur um mit Ihnen über Ihre Veranstaltungen in Kontakt zu
          treten.
        </p>
      </div>

      <basic-input
        label="Name"
        v-model="organizerInput.contact_name"
        class="sm:col-span-4"
        :error="errors['contact_name']"
      />

      <basic-input
        label="E-Mail"
        v-model="organizerInput.contact_email"
        class="sm:col-span-3"
        :error="errors['contact_email']"
      />

      <basic-input
        label="Telefonnummer"
        v-model="organizerInput.contact_phone"
        class="sm:col-span-3"
        :error="errors['contact_phone']"
      />

      <div v-if="!!organizerInput.legal_accepted_at" class="sm:col-span-6 text-gray-700">
        AGBs akzeptiert am {{ legalAcceptedAt }} Uhr
      </div>

      <basic-button @click="patch" :loading="loading" :disabled="loading" color="green"
        >Speichern</basic-button
      >
    </div>
  </div>
</template>

<script>
import BasicSelect from '@/components/basic/Select';
import accountClient from '@/api/central/account';
import dayjs from 'dayjs';

export default {
  props: ['organizer'],
  components: {
    BasicSelect,
  },

  data() {
    return {
      loading: false,
      errors: {},
      organizerInput: {},
    };
  },

  watch: {
    organizer: {
      handler() {
        this.organizerInput = JSON.parse(JSON.stringify(this.organizer));
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    legalAcceptedAt() {
      return dayjs(this.organizer.legal_accepted_at.local).format('DD.MM.YYYY HH:mm');
    },
  },

  methods: {
    patch() {
      this.loading = true;
      accountClient
        .patch(this.organizerInput)
        .then(() => {
          this.$emit('saved');
          this.$store.dispatch('account/getCurrentAccount');
          this.$store.dispatch('account/getAccountsByUser');
          this.$toasted.global.saved();
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.$toasted.global.error();
        })
        .then(() => (this.loading = false));
    },

    validateAll() {
      return this.$validator.validateAll();
    },
  },
};
</script>
